module.exports = __webpack_public_path__ + "assets/chat.5cd82c03.svg";